<template>
  <div>
    <navbar back fixed bg class="navbar">
      <span slot="title">贷款顾问个人详情</span>
    </navbar>
    <div class="consultant" :class="{noTop: isWechat}">
      <person :counselor-id="counselorId" :type-list="typeList" @show-modal="show = true"></person>
    </div>
    <div class="loantype" :class="{typeTop: isWechat}">
      <typebar @click-handler="clickHandler" :type-list="typeList" :select-type-index="selectTypeIndex"
               :active-color="'#21507f'" :color="'#97a1aa'"></typebar>
    </div>
    <modal :show="show" @close-modal="dismiss($event)" class="consultant-dialog" :hide-on-blur="true">
      <div class="page-caption">
        <h3 class="title">预约贷款服务<span class="iconfont pull-right" @click="dismiss($event)">&#xe61b;</span></h3>
        <div class="point"></div>
        <div class="line"></div>
      </div>
      <form class="appointment-wrap" novalidate="novalidate" @submit.prevent="loanReservation">
        <div class="common-style clearfix">
          <div class="pull-left common-padding">
            <label class="label">预&nbsp;约&nbsp;日&nbsp;期：</label>
          </div>
          <div class="pull-right" style="position: relative">
            <input type="text" v-model="selectedDate" autocomplete="off" readonly unselectable="on" style="width: 120px" @click="showDatePicker">
            <span class="iconfont" @click="showDatePicker">&#xe65a;</span>
            <datePicker
              :is-show="isShowDatePicker"
              @select-date="selectDate"
              :end-year="endYear"
              :end-month="endMonth"
              :end-date="endDate"
              :is-limit="true"/>
          </div>
        </div>
        <div class="common-style clearfix">
          <div class="pull-left common-padding">
            <label class="label">预&nbsp;约&nbsp;时&nbsp;间：</label>
          </div>
          <div class="pull-right" style="position: relative">
            <div class="time-wrap pull-left">
              <input type="text" v-model="getStartTime" autocomplete="off" style="width: 55px;text-align:center" @click="showTimePicker" readonly unselectable="on">
            </div>
            <div class="septal-line pull-left"></div>
            <div class="time-wrap pull-left" style="margin-left: 6px">
              <input type="text" v-model="getEndTime" autocomplete="off" style="width: 55px;text-align:center" @click="showTimePicker" readonly unselectable="on">
            </div>
            <span class="iconfont" @click="showTimePicker">&#xe65a;</span>
            <timePicker
              v-if="isShowTimePicker"
              :is-show="isShowTimePicker"
              :start-time="setPropsStartTime()"
              @select-start-time="selectStartTime"
              @select-end-time="selectEndTime"/>
          </div>
        </div>
        <div class="common-style clearfix">
          <div class="pull-left common-padding">
            <label class="label">联&nbsp;系&nbsp;人：</label>
          </div>
          <div class="pull-right">
            <input type="text" v-model="person" autocomplete="off"  style="width: 120px">
          </div>
        </div>
        <div class="common-style clearfix">
          <div class="pull-left common-padding">
            <label class="label">联&nbsp;系&nbsp;电&nbsp;话：</label>
          </div>
          <div class="pull-right">
            <input type="tel" v-model="phone" autocomplete="off" style="width: 120px">
          </div>
        </div>
        <div class="confirm-btn" >
          <p v-if="errmsg" style="font-size:7px;color:red;letter-spacing:2px;margin: 0"><span>{{errmsg}}</span>&nbsp;</p>
          <p v-if="!errmsg" style="font-size:7px;color:#7084a4;letter-spacing:2px;margin: 0;margin-bottom: 11px">我们会在您要求的时间与您联系！</p>
          <button type="submit">确定</button>
        </div>
      </form>
    </modal>
    <div class="page-content" ref="pageContent" :class="{contentTop: isWechat}">
      <scroller ref="scroller" :on-infinite="loadMore">
        <div class="perspective">
          <ul class="list-group">
            <router-link tag="li" :to="`/consultant/article/${counselorId}?id=${article.id}`" class="list-item" v-for="(article, index) in articleList" :key="index">
              <span class="iconfont" v-if="article.copyright === '原创'">&#xe695;</span>
              <span class="iconfont" v-if="article.copyright === '转载'">&#xe617;</span>
              <p>{{article.title}}</p>
              <span class="time text-right">{{article.auditDate}}</span>
            </router-link>
          </ul>
        </div>
      </scroller>
    </div>
  </div>
</template>
<script>
  import Person from './person'
  import Navbar from '../navbar/navbar'
  import Scroller from '../scroller/scroller'
  import Typebar from '../navbar/typebar'
  import Modal from '../modal/modal2'
  import DatePicker from '../picker/date'
  import TimePicker from '../picker/time'

  const MONTHRANGE = 3  // 贷款预约月份限制为距今3个月
  export default {
    data () {
      return {
        typeList: [],
        selectTypeIndex: null,
        loanType: null,
        counselorId: null,
        articleList: [],
        pageNumber: 0,
        pageSize: 20,
        hasmore: true,
        show: false,
//        copyRightMap: new Map(),
        // 日期
        isShowDatePicker: false,
        isShowTimePicker: false,
        selectedDate: '',
        startTime: null,
        endTime: null,
        endYear: null,
        endMonth: null,
        endDate: null,
        person: '',
        phone: '',
        errmsg: '',
        // 微信端
        isWechat: false
      }
    },
    components: {
      Person,
      Scroller,
      Typebar,
      Navbar,
      Modal,
      DatePicker,
      TimePicker
    },
    // 快速滑动
    mounted () {
      this.$nextTick(() => {
        this.scrollerContent = this.$refs.pageContent.getElementsByClassName('scroller-content')[0]
        setTimeout(() => {
          this.$refs.scroller.resize()
        }, 500)
      })
    },
    watch: {
      // 重置滑动加载的一些变量值
      loanType () {
        this.$refs.scroller.loadingState = 0
        this.$refs.scroller.scrollTo(0, 0)
        this.$refs.pageContent.style.height = '-1px'
        this.articleList = [].splice(0, this.articleList.length)
        this.$refs.scroller.resize()
      },
      selectedDate () {
        this.startTime = null
        this.endTime = null
      }
    },
    created () {
      // 具体贷款顾问
      this.counselorId = this.$route.params.uid
      this.getLoanTypeArr()
//      this._getCopyRightTag()
//      this.startTime = this.dateFormate(new Date())
//      this.startHour = this.dateFormate(new Date())
      // 处理时间
      this.endYear = new Date().getFullYear()
      this.endMonth = new Date().getMonth() + 1 + MONTHRANGE
      this.endDate = new Date().getDate()
      if (this.endMonth > 12) {
        this.endYear += Math.floor(this.endMonth / 12)
        this.endMonth = this.endMonth % 12
      }
      // 处理微信端状态
      if (this.$device.isWechat) {
        this.isWechat = true
      }
    },
    computed: {
      getStartTime () {
        return this.startTime && this.startTime + ':00'
      },
      getEndTime () {
        return this.endTime && this.endTime + ':00'
      }
    },
    methods: {
      // 获取贷款类型
      getLoanTypeArr () {
        let vm = this
        this.$ajax({
          url: '/getLoanTypeMap.jhtml',
          params: {
            cityNo: this.$cache.getCity().code
          },
          done (result) {
            vm.typeList = [].concat(result)
          }
        })
      },
      // 获取更多文章
      _fetchArticleListByLoanType (loanType) {
        let vm = this
        this.$ajax({
          url: '/getMoreArticleByCounselor.jhtml',
          params: {
            counselorId: vm.counselorId,
            loanType: loanType,
            isPage: 'y',
            pageNumber: this.pageNumber || 1,
            pageSize: vm.pageSize
          },
          done (articles, page) {
            vm.pageNumber = page.pageNumber
            vm.hasmore = page.count > 0 && page.pageNumber * page.pageSize < page.count
            vm.articleList = vm.articleList.concat(articles)
            if (vm.hasmore) {
              vm.$refs.scroller.finishInfinite(false)
            } else {
              vm.$refs.scroller.finishInfinite(true)
            }
          },
          always () {
            if (vm.scrollerContent) {
              vm.scrollerContent.style.transform = 'translate3d(0, 0, 0)'
              vm.scrollerContent.style.webkitTransform = 'translate3d(0, 0, 0)'
              vm.$refs.scroller.resize()
            }
          }
        })
      },
      // 获取文章类型
     /* _getCopyRightTag () {
        let vm = this
        this.$ajax({
          url: '/getLookupCdeList.jhtml',
          params: {
            typeCode: 20008005
          },
          done (result) {
            result.forEach(item => {
              vm.copyRightMap.set(item.cdeCode, item.cdeName)
            })
            vm.copyRightMap = Object.assign(new Map(), vm.copyRightMap)
          }
        })
      }, */
      // 点击获取不同类型的文章
      clickHandler (item, index) {
        this.hasmore = true
        this.pageNumber = 0
        this.loanType = item.id
        this.selectTypeIndex = index
      },
      // 滑动加载
      loadMore () {
        if (this.hasmore) {
          this.pageNumber++
          setTimeout(() => {
            this._fetchArticleListByLoanType(this.loanType)
          }, 500)
        } else {
          this.$refs.scroller.finishInfinite(true)
        }
      },
      setPropsStartTime () {
        let startTime = 1
        if (new Date(this.selectedDate).getTime() > new Date().getTime()) {
          return startTime
        }
        // if (this.startTime === null) {
        //   startTime = new Date().getHours()
        // } else {
        //   startTime = this.startTime
        // }
        startTime = new Date().getHours()
        return startTime
      },
      showDatePicker () {
        // 选择时间不能在选择日期
        if (this.isShowTimePicker) {
          this.isShowDatePicker = false
          return
        }
        this.isShowDatePicker = true
      },
      showTimePicker () {
        if (!this.selectedDate) {
          this.errmsg = '请先选择预约日期'
          return
        }
        this.isShowTimePicker = true
      },
      selectDate (year, month, date) {
        this.isShowDatePicker = false
        this.selectedDate = year + '-' + month + '-' + date
      },
      selectStartTime (startTime) {
        this.startTime = startTime
      },
      selectEndTime (endTime) {
        this.endTime = endTime
        this.isShowTimePicker = false
      },
      // 验证
      validate () {
        if (!this.selectedDate) {
          this.errmsg = '请先选择预约日期'
          return
        }
        if (!this.startTime) {
          this.errmsg = '请选择开始时间'
          return
        }
        if (!this.endTime) {
          this.errmsg = '请选择结束时间'
          return
        }
        if (!this.person || (/\s+/g.test(this.person))) {
          this.errmsg = '联系人不能为空'
          return
        }
        if (this.phone === '') {
          this.errmsg = '手机号不能为空'
          return
        }
        if (!(/^1\d{10}$/.test(this.phone))) {
          this.errmsg = '请输入正确手机号'
          return
        }
        this.errmsg = ''
        return true
      },
      // 预约成功后数据清空
      dismiss (e) {
        this.isShowDatePicker = false
        this.isShowTimePicker = false
        this.selectedDate = null
        this.startTime = null
        this.endTime = null
        this.person = ''
        this.phone = ''
        this.errmsg = ''
        this.show = false
      },
      loanReservation (e) {
        if (this.validate()) {
          let vm = this
          let time = new Date().getTime()
          this.$ajax({
            url: '/loanReservation.jhtml',
            params: {
              contact: vm.person,
              counselorId: vm.counselorId,
              contactNumber: vm.phone,
              reservationDate: vm.selectedDate,
              startTime: vm.startTime,
              endTime: vm.endTime,
              time: time,
              sign: vm.$md5('' + time + vm.counselorId + vm.person + vm.phone + vm.selectedDate + vm.startTime + vm.endTime + '1')
            },
            done () {
              vm.dismiss(e)
              vm.$dialog('预约成功！')
            },
            fail (m) {
              vm.errmsg = m
            }
          })
        }
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  @import '../../common/css/mixmin'
  .navbar
    height px2rem(88)
    &.navbar-fixed
      & ~ .page-content
        top px2rem(496)
        background-color rgba(255, 255, 255, 0.4)
  .consultant
    position absolute
    left 0
    top px2rem(88)
    z-index 100
  .loantype
    position absolute
    left 0
    right 0%
    z-index 100
    top px2rem(408)
    height px2rem(88)
    line-height px2rem(88)
    background-color #fff
    box-shadow 0 2px 6px 0 rgba(171,185,197,1)
  .page-content
    .list-group
      padding 0
      margin 0
      .list-item
        list-style none
        padding 0 px2rem(20px)
        border-bottom 1px dotted #275482
        height px2rem(84px)
        line-height px2rem(84px)
        .iconfont
          font-size px2rem(20px)
          color #25A6DD
          float left
        p
          float left
          margin 0
          margin-left 2px
          width px2rem(400px)
          color #275482
          font-size px2rem(24px)
          ellipsis()
        .time
          float right
          color #275482
          font-size px2rem(20px)

  .noTop
    top 0
  .contentTop
    top px2rem(408)
  .typeTop
    top px2rem(320)
</style>



// WEBPACK FOOTER //
// article-list.vue?0b6aafb9